module.exports = __webpack_public_path__ + "ship_with_yachts.51c7e57.jpg";